import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import {
  Paper,
  MenuItem,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import API from '../../api';
import defaultCompanyImage from '../../assets/default_company.png';
import './AdvertiserSelector.scss';

export class AdvertiserSelector extends Component {
  constructor(props) {
    super(props);

    this.inputRef = React.createRef();

    this.state = {
      advertisers: [],
      isAdvertisersOpen: false,
      selectedAdvertiserIndex: 0,
      advertiserImageUrl: '',
    };
  }

  componentDidMount() {
    const {
      user,
      advertiserId,
      advertiserName,
      setAdvertiser,
      onChange,
    } = this.props;

    if (advertiserName || !user.can('admin.system_admin')) {
      const searchName = advertiserName;

      API.Advertiser.list({
        filters: {
          name: searchName,
          active: true,
        },
      }).then((result) => {
        const advertiser = get(result, 'data[0]', {});

        setAdvertiser({
          advertiserId: advertiser._id,
          advertiserName: advertiser.name,
        });

        onChange({
          target: {
            value: advertiser._id,
          },
        });

        this.setState({
          advertiserImageUrl: advertiser.imageUrl,
        });
      });
    } else if (user.can('advertiser.view') && advertiserId && !advertiserName) {
      API.Advertiser.getById(advertiserId).then((advertiser) => {
        setAdvertiser({
          advertiserId: advertiser._id,
          advertiserName: advertiser.name,
        });

        this.setState({
          advertiserImageUrl: advertiser.imageUrl,
        });
      });
    }
  }

  onFocus = () => {
    const {
      onFocus,
    } = this.props;
    onFocus();
  };

  onChangeAdvertiser = (e) => {
    const {
      setAdvertiser,
      onChange,
    } = this.props;

    const {
      target: {
        value = '',
      },
    } = e;

    setAdvertiser({
      advertiserName: value,
    });

    // Advertiser must be selected from the dropdown list
    onChange({
      target: {
        value: '',
      },
    });

    if (value === '') {
      this.setState({
        advertisers: [],
        isAdvertisersOpen: false,
        selectedAdvertiserIndex: 0,
        advertiserImageUrl: '',
      });

      return;
    }

    const searchName = value.trim();

    API.Advertiser.list({
      filters: {
        name: searchName,
        active: true,
      },
    }).then((result) => {
      const advertisers = result.data;

      this.setState({
        advertisers,
        isAdvertisersOpen: true,
      });
    });
  };

  onBlurAdvertiser = (e) => {
    const {
      onBlur,
    } = this.props;

    // Ensure blur fires after selecting a advertiser
    setTimeout(() => {
      this.setState({
        advertisers: [],
        isAdvertisersOpen: false,
        selectedAdvertiserIndex: 0,
      });
    }, 500);

    onBlur(e);
  };

  onKeyDownAdvertiser = (e) => {
    const {
      setAdvertiser,
      onChange,
    } = this.props;

    if (e.key === 'ArrowDown') {
      this.setState((state) => {
        const nextIndex = state.selectedAdvertiserIndex + 1;

        return {
          selectedAdvertiserIndex: nextIndex < state.advertisers.length ? nextIndex : state.advertisers.length - 1,
        };
      });
    } else if (e.key === 'ArrowUp') {
      this.setState((state) => {
        const prevIndex = state.selectedAdvertiserIndex - 1;

        return {
          selectedAdvertiserIndex: prevIndex >= 0 ? prevIndex : 0,
        };
      });
    } else if (e.key === 'Enter') {
      this.setState((state) => {
        const advertiser = get(state, `advertisers[${state.selectedAdvertiserIndex}]`, null);

        if (!advertiser) {
          // No advertiser found to select
          return state;
        }

        setAdvertiser({
          advertiserId: advertiser._id,
          advertiserName: advertiser.name,
        });

        onChange({
          target: {
            value: advertiser._id,
          },
        });

        return {
          advertisers: [],
          isAdvertisersOpen: false,
          selectedAdvertiserIndex: 0,
          advertiserImageUrl: advertiser.imageUrl,
        };
      });
    }
  };

  selectAdvertiser = (advertiser) => {
    const {
      setAdvertiser,
      onChange,
    } = this.props;

    setAdvertiser({
      advertiserId: advertiser._id,
      advertiserName: advertiser.name,
    });

    onChange({
      target: {
        value: advertiser._id,
      },
    });

    this.setState({
      advertiserImageUrl: advertiser.imageUrl,
      advertisers: [],
      isAdvertisersOpen: false,
      selectedAdvertiserIndex: 0,
    });
  };

  clearAdvertiser = () => {
    const {
      setAdvertiser,
      onChange,
    } = this.props;

    const {
      inputRef: {
        current: inputRef,
      },
    } = this;

    setAdvertiser({
      advertiserId: '',
      advertiserName: '',
    });

    onChange({
      target: {
        value: '',
      },
    });

    this.setState({
      advertiserImageUrl: '',
    });

    if (inputRef) {
      inputRef.focus();
    }
  };

  render() {
    const {
      fieldId,
      advertiserName,
      disabled,
      tabIndex,
    } = this.props;

    const {
      advertisers,
      isAdvertisersOpen,
      selectedAdvertiserIndex,
      advertiserImageUrl,
    } = this.state;

    const advertiserImage = advertiserName
      ? advertiserImageUrl || defaultCompanyImage
      : defaultCompanyImage;

    return (
      <div className="AdvertiserSelector">
        <div className="advertiser-input-container">
          <input
            ref={this.inputRef}
            tabIndex={tabIndex}
            className="field-input advertiser-input"
            id={fieldId}
            name="advertiser"
            type="text"
            placeholder="Advertiser"
            value={advertiserName}
            onFocus={this.onFocus}
            onChange={this.onChangeAdvertiser}
            onBlur={this.onBlurAdvertiser}
            onKeyDown={this.onKeyDownAdvertiser}
            autoComplete="off"
            disabled={disabled}
          />

          <div className="advertiser-image">
            <img src={advertiserImage} alt="Advertiser" />
          </div>

          {!disabled ? (
            <div className="advertiser-clear">
              <Close
                className="advertiser-clear-icon"
                onClick={this.clearAdvertiser}
              />
            </div>
          ) : null}
        </div>

        {isAdvertisersOpen ? (
          <Paper
            className="advertiser-select"
            square
          >
            {advertisers.map((advertiser, index) => {
              return (
                <MenuItem
                  key={advertiser._id}
                  selected={selectedAdvertiserIndex === index}
                  component="div"
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={this.selectAdvertiser.bind(this, advertiser)}
                >
                  <div className="advertiser-item">
                    <div className="advertiser-image left">
                      <img src={advertiser.imageUrl || defaultCompanyImage} alt="Advertiser" />
                    </div>
                    <div className="advertiser-name">
                      {advertiser.name}
                    </div>
                  </div>
                </MenuItem>
              );
            })}
          </Paper>
        ) : null}
      </div>
    );
  }
}

AdvertiserSelector.propTypes = {
  fieldId: PropTypes.string,
  advertiserId: PropTypes.string,
  advertiserName: PropTypes.string,
  disabled: PropTypes.bool,
  /** Input tab index position */
  tabIndex: PropTypes.number,
  setAdvertiser: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

AdvertiserSelector.defaultProps = {
  fieldId: 'advertiser-selector',
  advertiserId: '',
  advertiserName: '',
  disabled: false,
  tabIndex: 0,
  setAdvertiser: () => {},
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(AdvertiserSelector);
